import { Grid, useMediaQuery } from "@mui/material";
import React, { useState, useEffect } from "react";
import { CustomTabPanel } from "../../../components/tabComponent";
import SimpleSelect from "../../../components/selects/simpleSelect";
import LaddaButton from "../../../components/buttons/laddaButton";
import { useNavigate } from "react-router-dom";
import { icons } from "../../../constants";
import { useForm } from "react-hook-form";
import { months } from "../../../constants/selectData";
import SimpleTable from "../../../components/tables/simpleTable";
import { stakedColumnChartOptions } from "../../../components/highchartsComponent/charts/stackedColumn";
import {
  getCurrentMonth,
  getCurrentYear,
  getMonthName
} from "../../../utils/dateUtils";
import { getCookie } from "../../../utils/getCookie";
import GraphSection from "../graphSection";
import { useDispatch } from "react-redux";
import { setBreadCrumData } from "../../../redux/slices/breadCrumbSlice";
import { callApiAsync, getCallRisksResume } from "../../../services/apiService";
import { actualYearSelect } from "../../../services/dateService";
import { isRiskVersion } from "../../../utils/riskAndOportunityVersion";
import { canManageAnyRiskAndOppProcess } from "../../../constants/riskAndOpportunityRoles";

const RiskTab = ({ userData, userId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [dataTable, setDataTable] = useState([]);
  const [dataTotal, setDataTotal] = useState(0);
  const [extraData, setExtraData] = useState({
    month: getCurrentMonth(),
    year: getCurrentYear()
  });
  const userSesion = getCookie("sesion");
  const { control, getValues, setValue, watch } = useForm();

  const isSmallScreen = useMediaQuery("(max-width:590px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");

  const useVersion2 = isRiskVersion(watch("year"), watch("month")) === 2;

  const columnsRiskV2 = [
    { field: "processName", header: "Procesos" },
    { field: "superiorLevel", header: "Nivel Superior" },
    { field: "highLevel", header: "Nivel Alto" },
    { field: "mediumLevel", header: "Nivel Medio" },
    { field: "lowLevel", header: "Nivel Bajo" },
    { field: "total", header: "Total" },
    { field: "actions", header: "", columnType: "actionButtons" }
  ];

  const columnsRiskV1 = [
    { field: "processName", header: "Procesos" },
    { field: "highLevel", header: "Nivel Alto" },
    { field: "mediumLevel", header: "Nivel Medio" },
    { field: "lowLevel", header: "Nivel Bajo" },
    { field: "total", header: "Total" },
    { field: "actions", header: "", columnType: "actionButtons" }
  ];

  const columnsRisk = useVersion2 ? columnsRiskV2 : columnsRiskV1;

  const dataTableDisplay = useVersion2
    ? dataTable
    : dataTable.map((row) => ({
        ...row,
        highLevel: String(
          parseInt(row.highLevel || 0, 10) + parseInt(row.superiorLevel || 0, 10)
        )
      }));

  const canCreateRisk = canManageAnyRiskAndOppProcess(userData?.roleList);

  useEffect(() => {
    setValue("year", getCurrentYear());
    setValue("month", getCurrentMonth());
    filterData(getCurrentYear(), getCurrentMonth());
  }, []);

  const handleChange = async () => {
    const formData = getValues();
    setExtraData(formData);
    filterData(formData.year, formData.month);
  };

  const filterData = async (yearSelected, monthSelected) => {
    callApiAsync(
      () =>
        getCallRisksResume(userSesion.id_usuario, yearSelected, monthSelected),
      (data) => {
        setDataTable(data.table);
        setDataTotal(data.totalCount);
      }
    );
  };

  return (
    <CustomTabPanel value="1">
      <div className="HContainer mb-10">
        <div className="totalRiskContainer VContainer align-center">
          <p className="totalmonthrisk-number">{dataTotal}</p>
          <p className="totalmonthrisk-label">
            Total Riesgos en {getMonthName(watch("month"))} {watch("year")}
          </p>
        </div>

        <div className="creationButtonFilterContainer">
          <div>
            {canCreateRisk && (
              <LaddaButton
                variant="contained"
                onClick={() => {
                  navigate("/riskAndOpportunityManagement/createRisk", {
                    state: extraData
                  });
                }}
                borderRadius={"15px"}
                width={"100%"}
                height={"40px"}
                color={"#141313"}
                margin={
                  isMediumScreen
                    ? "5px 0 10px 0"
                    : isSmallScreen
                    ? "5px 0 0 0 "
                    : "0 10px 10px 0"
                }
                backgroundColor={"#EFCD00"}
              >
                <div className="IHContainer align-center">
                  <img
                    className="btn-icon"
                    src={icons.exclamationboard}
                    alt="icon"
                    style={{ marginRight: "10px" }}
                  />
                  <p
                    className={
                      isMediumScreen ? "button_text_mini" : "button_text"
                    }
                  >
                    Crear Nuevo Riesgo
                  </p>
                </div>
              </LaddaButton>
            )}
          </div>

          <div className="info-form-container">
            <form>
              <Grid container>
                <Grid item xs={12} md={6}>
                  <div
                    className={
                      isMediumScreen
                        ? "mb-20"
                        : isSmallScreen
                        ? "mb-10"
                        : "mr-10"
                    }
                  >
                    <SimpleSelect
                      name="month"
                      control={control}
                      label="Mes"
                      options={months}
                      onChange={handleChange}
                      margin={"0"}
                    />
                  </div>
                </Grid>

                <Grid item xs={12} md={6}>
                  <SimpleSelect
                    name="year"
                    control={control}
                    label="Año"
                    options={actualYearSelect}
                    onChange={handleChange}
                    margin={"0"}
                  />
                </Grid>
              </Grid>
            </form>
          </div>
        </div>
      </div>

      <SimpleTable
        data={dataTableDisplay}
        columns={columnsRisk}
        tableStyle={{ minWidth: "870px" }}
        buttons={[
          {
            type: "redirectData",
            icon: icons.eye,
            url: "/riskAndOpportunityManagement/riskAdminGestion",
            extraData: extraData
          }
        ]}
      />
      <GraphSection
        title={"DETALLES DE RIESGO"}
        filters={"risk"}
        typeGraph={stakedColumnChartOptions}
      />
    </CustomTabPanel>
  );
};

export default RiskTab;
